var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftteamsSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#485BD5",
  d: "M19.182 10.523h-3.955v3.954c0 1.296 1.091 2.387 2.387 2.387 1.295 0 2.386-1.091 2.386-2.387v-3.136c0-.477-.34-.818-.818-.818"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6D81FF",
  d: "M8.955 10.523v4.772c0 1.978 1.568 3.75 3.681 3.887 2.319.136 4.228-1.568 4.228-3.75v-4.16c0-.408-.341-.75-.819-.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5161CB",
  d: "M12.91 5c-.82 0-1.637.477-2.046 1.16-.41.68-.41 1.635 0 2.385.409.75 1.227 1.16 2.045 1.16s1.636-.478 2.046-1.16.409-1.636 0-2.386C14.545 5.41 13.727 5 12.909 5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3440A0",
  d: "M17.614 5.818c-.887 0-1.569.682-1.569 1.568 0 .887.682 1.569 1.569 1.569s1.568-.682 1.568-1.569-.682-1.568-1.568-1.568"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D399A",
  d: "M12.227 16.045H5.682c-.341 0-.682-.272-.682-.613V9.568c0-.34.273-.613.682-.613h6.545c.341 0 .682.272.682.613V15.5c0 .273-.34.545-.682.545"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.523 10.523H7.386v.682h1.16v3.272h.818v-3.272h1.159z"
}))));
export { SvgMicrosoftteamsSmall as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoftteamsSmall.efa13e6a.svg";